module.exports = __webpack_public_path__ + "img/ranking-bg-icon.c130b396.png";